module.exports = __webpack_public_path__ + "img/IMG_9713.9682090e.jpeg";